import { element } from 'angular';
import { Injectable } from 'angular-ts-decorators';
import { TranslationKey } from './translation-key.enum';

interface IDictionary {
  key: string;
  value: string;
}
export interface ITranslationService {
  getSystem(key: string | TranslationKey): string | TranslationKey;
}

@Injectable('translation')
export class TranslationService implements ITranslationService {
  public static $inject: ReadonlyArray<string> = [];

  private systemDictionary: IDictionary[] = [];

  constructor() {
    const systemHtml: string = element('#system-dictionary').html();

    if (systemHtml) {
      this.systemDictionary = JSON.parse(systemHtml) as IDictionary[];
      element('#system-dictionary').remove();
    }
  }

  public getSystem(key: string | TranslationKey): string | TranslationKey {
    const systemDictionaryItem: IDictionary = this.systemDictionary
      .filter((sd: IDictionary): boolean => sd.key === key)[0];
    return systemDictionaryItem?.value || '';
  }
}
